import React from "react";
import "./financials.css";
import Header from "../../../component/header";
import SideNav from "../../../component/sideNav";
import FinacialDetail from "./financialsDetail";

export default function Financial() {
  return (
    <div className="financialContainer">
      <Header></Header>
      <SideNav active="Dashboard" />
      <div className="financialContent">
        <FinacialDetail></FinacialDetail>
      </div>
    </div>
  );
}
